import { Lock, CreditCard } from "lucide-react";
import { CURRICULUM } from "@/lib/curriculum";
import { startStripeCheckout } from "@/lib/payments";
import { DashboardModuleCard } from "@/components/dashboard/DashboardModuleCard";

export const DashboardModules = ({ hasModules, completed, videosAvailable, userId, onToggleDone, onShare }) => {
  const unlock = () => startStripeCheckout("bundle", userId);
  return (
    <>
      <div id="dashboard-modules" className="flex items-center justify-between mt-16 mb-6 gap-4 flex-wrap scroll-mt-32">
        <div className="section-tag">§ The 8 Modules</div>
        <span
          data-testid="dashboard-access-state"
          className={`font-mono text-[10px] tracking-[0.25em] uppercase px-3 py-1.5 rounded-full border ${hasModules ? "text-emerald-400 border-emerald-400/40" : "text-[#78716C] border-[#E7DFD5]"}`}
        >
          {hasModules ? "Unlocked" : "Locked · Preview"}
        </span>
      </div>

      {!hasModules && (
        <div data-testid="dashboard-unlock-banner" className="tacc-card p-6 md:p-8 mb-6 flex flex-col md:flex-row md:items-center justify-between gap-6">
          <div className="flex items-start gap-4">
            <Lock size={22} className="text-[#B45309] mt-1 shrink-0" strokeWidth={1.4} />
            <div>
              <h4 className="font-heading text-lg tracking-tight mb-1">Unlock all 8 modules</h4>
              <p className="text-[#78716C] text-sm max-w-lg">Pay by card right here to unlock all 8 video modules — Rich on camera, the teaching, and every reflection question. Watch on this site, lifetime access.</p>
            </div>
          </div>
          <button onClick={unlock} data-testid="dashboard-unlock-btn" className="btn-ember text-sm shrink-0">
            <CreditCard size={16} /> Unlock — $77
          </button>
        </div>
      )}

      <div className={`grid grid-cols-12 gap-4 ${hasModules ? "" : "opacity-60"}`}>
        {CURRICULUM.map((m, i) => (
          <DashboardModuleCard
            key={m.id}
            m={m}
            index={i}
            hasModules={hasModules}
            done={completed.includes(m.id)}
            hasVideo={videosAvailable.includes(m.id)}
            onToggleDone={() => onToggleDone(m.id)}
            onShare={() => onShare(m.id)}
            onUnlock={unlock}
          />
        ))}
      </div>
    </>
  );
};
